export enum ContentTypes {
  Articles = 'Articles',
  Blog = 'Blog',
  News = 'News',
  Question = 'Question',
}

export enum UserLike {
  Like = 1,
  Dislike = -1,
}

export interface ISimilarContentItem {
  id: number;
  type: string;
  title: string;
  image: string;
  datePublish: string;
  numViews: number;
  category: string;
  slug: string;
  subtitle: string;
  author: string;
  imageThumbnail: string;
  imageThumbnailMobile: string;
  commentsCount: number;
  advertising: boolean;
}

export interface IComment {
  id: number;
  comment: string;
  submitDate: string;
  datePublish: string;
  parentId: number | null;
  comments: IComment[];
  likesCount?: number;
  dislikesCount?: number;
  bestAdvice?: boolean;
  userLike?: UserLike | null;
  attributes?: {
    comment: string;
    contentObject?: {
      id: number;
      slug: string;
      subtitle: string;
      title: string;
      type: string;
    };
  };
}

export interface ISentComment {
  comment: string;
  userId: number;
  fullName: string;
  email: string;
}

export interface IRegion {
  id: number;
  name: string;
  penName: string;
}

export interface IContentItem {
  id: string;
  type: ContentTypes;
  attributes: {
    content: string;
    category: string;
    datePublish: string;
    image: string;
    numViews: number;
    subtitle: string;
    title: string;
    author: string;
    slug: string;
    tags?: string[];
    seoUrl?: string;
    seoTitle?: string;
    seoDescription?: string;
    seoKeywords?: string;
    noIndex?: boolean;
    advertising?: boolean;
    similarJournals?: ISimilarContentItem[];
    comments: IComment[];
    isSubscribedToComments?: boolean;
    status?: string;
    likesCount?: number;
    dislikesCount?: number;
    regions: IRegion[];
    rubrics: number[];
    blockDescription?: string;
    blockReason?: string;
    votesCount?: number;
    userLike?: UserLike | null;
  };
}

export type TContentItemState = IContentItem | null;
